import { T } from "@tolgee/react";
import { FC } from "react";
import { Button } from "../ui";
import { useAtomValue } from "jotai";
import { crpQuestionnaireUrlAtom } from "../../jotai-atoms";

export const NavigateToCrp1QuestionnaireButton: FC = () => {
  const crpQuestionnaireUrl = useAtomValue(crpQuestionnaireUrlAtom);

  const handleNavigateToCrpQuestionnaire = () => {
    window.open(crpQuestionnaireUrl, "_blank");
  };

  return (
    <Button
      className="p-2 !text-xs !leading-[18px]"
      onClick={handleNavigateToCrpQuestionnaire}
    >
      <T keyName="check-crp-quantities-dialog-content-button-text" />
    </Button>
  );
};
